import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import RequireAuth from "./services/RequireAuth";
import RequireBroker from "./services/RequireBroker";

import CheckCompany from "./pages/CheckCompany";
import Dashboard from "./pages/Dashboard";
import PMStudio from "./pages/PMStudio";
import DueDiligencePortal from "./pages/duediligence";
import DataRoom from "./pages/dataroom";
import Valuation from "./pages/Valuation";
import PMTemplatePicker from "./pages/PMTemplatePicker";
import PMStudioEditorPage from "./pages/pmstudio/PMStudioEditor";
import Projects from "./pages/Projects";
import Logg from "./pages/Logg";
import BrokerSettings from "./pages/BrokerSettings";
import WorkspaceSettings from "./pages/WorkspaceSettings";

import FreeValuationLanding from "./pages/freevaluation/FreeValuationLanding";
import FreeValuationForm from "./pages/freevaluation/FreeValuationForm";
import FreeValuationProcessing from "./pages/freevaluation/FreeValuationProcessing";
import FreeValuationDone from "./pages/freevaluation/FreeValuationDone";
import FreeValuationExpired from "./pages/freevaluation/FreeValuationExpired";

import Login from "./pages/login/Login";
import ForgotPassword from "./pages/login/ForgotPassword";
import ResetPassword from "./pages/login/ResetPassword";
import Logout from "./pages/login/Logout";
import AcceptInvite from "./pages/login/AcceptInvite";
import AcceptWorkspaceInvite from "./pages/login/AcceptWorkspaceInvite";
import AcceptBuyerInvite from "./pages/login/AcceptBuyerInvite";
import SellerPortalLayout, {
  SellerDataroomPage,
  SellerQAPage,
  SellerFinancialsPage,
  SellerDDPage,
  SellerCompanyDetailsPage,
  SellerValuationPage,
  SellerIMPage,
} from "./pages/SellerPortal";
import BuyerPortalLayout, {
  BuyerDataroomPage,
  BuyerQAPage,
  BuyerValuationPage,
  BuyerIMPage,
  BuyerDDPage,
} from "./pages/BuyerPortal";
import WorkspaceTeamPage from "./pages/portal/WorkspaceTeamPage";
import WorkspaceNDAEditor from "./pages/WorkspaceNDAEditor";
import WorkspaceLOIEditor from "./pages/WorkspaceLOIEditor";
import Koncern from "./pages/Koncern";
import PdfEditorPage from "./pages/IMStudio";
import FinancePage from "./pages/Finance";
import ProspectSearch from "./pages/ProspectSearch";
import BuyerSearch from "./pages/BuyerSearch";
import Pipeline from "./pages/Pipeline";
import DDDelegatePortal from "./pages/DDDelegatePortal";
import Activity from "./pages/Activity";
import Notes from "./pages/Notes";
import Tasks from "./pages/Tasks";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/invite/accept/:token" element={<AcceptInvite />} />
        <Route path="/workspace-invite/accept/:token" element={<AcceptWorkspaceInvite />} />
        <Route path="/buyer-invite/accept/:token" element={<AcceptBuyerInvite />} />
        <Route path="/dd/delegate/:token" element={<DDDelegatePortal />} />

        {/* Free-valuation funnel — public marketing flow.
            /verifiera is not a React page; the backend redirect target
            takes the magic-link token, verifies + logs in, and
            redirects here to /formular directly. */}
        <Route path="/gratis-vardering" element={<FreeValuationLanding />} />
        <Route path="/gratis-vardering/formular" element={<FreeValuationForm />} />
        <Route path="/gratis-vardering/behandlas/:workspaceId" element={<FreeValuationProcessing />} />
        <Route path="/gratis-vardering/klart/:workspaceId" element={<FreeValuationDone />} />
        <Route path="/gratis-vardering/lank-utgangen" element={<FreeValuationExpired />} />

        {/* Default */}
        <Route path="/" element={<Navigate to="/projects" replace />} />

        {/* Protected */}
        <Route
          path="/projects"
          element={
            <RequireAuth>
              <Projects />
            </RequireAuth>
          }
        />

        <Route
          path="/check"
          element={
            <RequireBroker>
              <CheckCompany />
            </RequireBroker>
          }
        />

        <Route
          path="/prospect"
          element={
            <RequireBroker>
              <ProspectSearch />
            </RequireBroker>
          }
        />

        <Route
          path="/hitta-kopare/:company/*"
          element={
            <RequireAuth>
              <BuyerSearch />
            </RequireAuth>
          }
        />
        <Route
          path="/hitta-kopare"
          element={
            <RequireAuth>
              <BuyerSearch />
            </RequireAuth>
          }
        />

        <Route
          path="/dashboard/:company/*"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/pipeline/:company/*"
          element={
            <RequireAuth>
              <Pipeline />
            </RequireAuth>
          }
        />
        <Route
          path="/logg/:company/*"
          element={
            <RequireAuth>
              <Logg />
            </RequireAuth>
          }
        />
        <Route
          path="/pm/:company/*"
          element={
            <RequireAuth>
              <PdfEditorPage />
            </RequireAuth>
          }
        />
        <Route
          path="/valuation/:company/*"
          element={
            <RequireAuth>
              <Valuation />
            </RequireAuth>
          }
        />
               <Route
       path="/settings"
          element={
            <RequireAuth>
              <BrokerSettings />
            </RequireAuth>
          }
        />
        <Route
          path="/duediligence/:company/*"
          element={
            <RequireAuth>
              <DueDiligencePortal />
            </RequireAuth>
          }
        />
<Route
  path="/settings/:company/*"
  element={
    <RequireAuth>
      <WorkspaceSettings />
    </RequireAuth>
  }
/>
        <Route
          path="/dataroom/:company/*"
          element={
            <RequireAuth>
              <DataRoom />
            </RequireAuth>
          }
        />

        <Route
          path="/company/:company/pm/templates"
          element={
            <RequireAuth>
              <PMTemplatePicker />
            </RequireAuth>
          }
        />
        <Route
          path="/company/:company/pm/editor"
          element={
            <RequireAuth>
              <PMStudioEditorPage />
            </RequireAuth>
          }
        />

        <Route
          path="/koncern/:company/*"
          element={
            <RequireAuth>
              <Koncern />
            </RequireAuth>
          }
        />

        {/* Seller portal — layout + per-module sub-pages */}
        <Route
          path="/seller/:company"
          element={
            <RequireAuth>
              <SellerPortalLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="dataroom" replace />} />
          <Route path="dataroom" element={<SellerDataroomPage />} />
          <Route path="qa" element={<SellerQAPage />} />
          <Route path="financials" element={<SellerFinancialsPage />} />
          <Route path="dd" element={<SellerDDPage />} />
          <Route path="company" element={<SellerCompanyDetailsPage />} />
          <Route path="valuation" element={<SellerValuationPage />} />
          <Route path="im" element={<SellerIMPage />} />
          <Route path="team" element={<WorkspaceTeamPage />} />
        </Route>

        {/* Buyer portal — layout + per-module sub-pages */}
        <Route
          path="/buyer/:company"
          element={
            <RequireAuth>
              <BuyerPortalLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="dataroom" replace />} />
          <Route path="dataroom" element={<BuyerDataroomPage />} />
          <Route path="qa" element={<BuyerQAPage />} />
          <Route path="valuation" element={<BuyerValuationPage />} />
          <Route path="im" element={<BuyerIMPage />} />
          <Route path="dd" element={<BuyerDDPage />} />
          <Route path="team" element={<WorkspaceTeamPage />} />
        </Route>

        <Route
          path="/nda-editor/:company"
          element={
            <RequireAuth>
              <WorkspaceNDAEditor />
            </RequireAuth>
          }
        />

        <Route
          path="/loi-editor/:company"
          element={
            <RequireAuth>
              <WorkspaceLOIEditor />
            </RequireAuth>
          }
        />

        <Route
          path="/finance/:company/*"
          element={
            <RequireAuth>
              <FinancePage />
            </RequireAuth>
          }
        />

        <Route
          path="/activity/:company/*"
          element={
            <RequireAuth>
              <Activity />
            </RequireAuth>
          }
        />
        <Route
          path="/notes/:company/*"
          element={
            <RequireAuth>
              <Notes />
            </RequireAuth>
          }
        />
        <Route
          path="/tasks/:company/*"
          element={
            <RequireAuth>
              <Tasks />
            </RequireAuth>
          }
        />

        <Route path="*" element={<Navigate to="/projects" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
